import { RoleTypeEnum } from '../role-type';

export const UserRoleMapper: Record<RoleTypeEnum, string> = {
	[RoleTypeEnum.Doctor]: 'D',
	[RoleTypeEnum.Lab]: 'L',
	[RoleTypeEnum.Technician]: 'T'
};
